// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.doc_req_pop[data-v-137df34a] {width:910px; height: 600px; overflow-y: scroll;}\n.doc_req_pop > .layer_close[data-v-137df34a] {z-index: 10;}\n.div_cntr_area + .div_cntr_area[data-v-137df34a] {margin-top: 5px;}\n.text_link[data-v-137df34a] {color: #000; padding-left: 2px;}\n.text_link[data-v-137df34a]:hover {text-decoration: underline !important;}\n.attdel[data-v-137df34a] {cursor: pointer;}\n", ""]);
// Exports
module.exports = exports;
